import React from 'react'
import { UserInfoTooltip } from '../UserInfoTooltip'

export const Author = ({ identifier, isCustomer }) =>
  isCustomer ? <span>Kunde</span> : <UserInfoTooltip identifier={identifier} />
